import mqtt from 'mqtt';

export default {
  install: (Vue) => {
    const mqttUrl = process.env.VUE_APP_MQTT_URL;

    const mqttClient = mqtt.connect(mqttUrl, {
      clientId: `mqtt_vue_client_${Math.random().toString(16).substr(2, 8)}`,
      username: 'test',
      password: 'test',
      keepalive: 55,
      clean: true,
      resubscribe: true,
      reconnectPeriod: 3000,
      connectTimeout: 30000
    });

    mqttClient.on('connect', () => {
      console.log('MQTT connected');
    });

    mqttClient.on('error', (error) => {
      console.error('MQTT connection error:', error);
    });

    mqttClient.on('close', () => {
      console.log('MQTT connection closed');
    });

    mqttClient.on('reconnect', () => {
      console.log('MQTT reconnecting...');
    });

    mqttClient.stream.on('close', () => {
      console.log('Socket closed by network');
    });

    // Add the client to Vue prototype
    Vue.prototype.$mqtt = mqttClient;
  }
};
